import React from 'react';

// styles
import './styles.scss';

// assets
import assets from '../../../Assets';

// custom components
import Button from 'Components/Button';

const SuccessCard = ({ title = 'Added Successfully', subTitle = 'Product Training Program Details Added Successfully.', buttonText = 'Go Back', onClose, onGoBack }) => {
  return (
    <div className="success-screen">
      <div className="SuccessCardContainer">
        {/* Close icon action */}
        <div className="SuccessCardCloseIcon" onClick={onClose}>
          <img src={assets.Icons.closeIcon} alt="closeIcon" />
        </div>
        <div className="SuccessCardContents">
          <img src={assets.Images.successPopupImage} alt="SuccessImage" />
          <p className="SuccessCardTitle">{title}</p>
          <p className="SuccessCardSubTitle">{subTitle}</p>
          <div className="SuccessCardButtonContainer">
            <Button title={buttonText} onClick={onGoBack} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessCard;
